import basePdfs from './basePdfs.json'

export default {
    getScenarioAvailableTemplates(scenario) {
        // Returns the available reports that can be generated according to the project scenario
        if (scenario == 'cardiosafe') {
            return [
                {
                    name: 'Dose effect on QT',
                    description: 'X1: Dose, Y1: QT | X2: Dose, Y2: dQT',
                    xAttrs: ['scalars.Dose', 'scalars.Dose'],
                    yAttrs: ['scalars.dQT', 'scalars.QT'],
                    colorTags: [null, null],
                    regressionGroupsToHide: [[null], [null]],
                    buttonLabel: 'export',
                    plotCount: 2
                },
            ]
        } else if (scenario == 'CRT') {
            return []
        }
    },
    getScenarioDataStructure(scenario) {
        // Prepares the data structure depending on the project scenario (only supports ITQT for now)
        if (scenario == 'cardiosafe') 
            return {
                "drug": {
                    "type": "text",
                    "position": {
                    "x": 111,
                    "y": 56
                    },
                    "width": 70,
                    "height": 7,
                    "alignment": "left",
                    "fontSize": 10,
                    "characterSpacing": 0,
                    "lineHeight": 1
                },
                "concentrations": {
                    "type": "text",
                    "position": {
                    "x": 111,
                    "y": 67.64
                    },
                    "width": 70,
                    "height": 7,
                    "alignment": "left",
                    "fontSize": 10,
                    "characterSpacing": 0,
                    "lineHeight": 1
                },
                "anatomies": {
                    "type": "text",
                    "position": {
                    "x": 111,
                    "y": 79.57
                    },
                    "width": 70,
                    "height": 7,
                    "alignment": "left",
                    "fontSize": 10,
                    "characterSpacing": 0,
                    "lineHeight": 1
                },
                "subjects": {
                    "type": "text",
                    "position": {
                    "x": 111,
                    "y": 91
                    },
                    "width": 70,
                    "height": 7,
                    "alignment": "left",
                    "fontSize": 10,
                    "characterSpacing": 0,
                    "lineHeight": 1
                },
            } 
    },
    getTemplateBasePdf(scenario, plotCount) {
        // Returns base pdf in base64 format, according to scenario and template
        if(scenario == 'cardiosafe') {
            if(plotCount == 1) return basePdfs.cardiosafe.pages2
            else if(plotCount == 2) return basePdfs.cardiosafe.pages3
            else if (plotCount == 3) return basePdfs.cardiosafe.pages4
            else if (plotCount == 4) return basePdfs.cardiosafe.pages5
        }
        
    },
}
